import type { ReactNode } from "react";
import { AlertTriangle, CheckCircle2, CircleDot, PauseCircle, XCircle } from "lucide-react";
import type { ReminderLevel } from "@navibiz/chat-core";
import styles from "./Badge.module.css";

export type Tone = "neutral" | "accent" | "good" | "warning" | "serious" | "critical";

export function Badge({ tone = "neutral", icon, children }: { tone?: Tone; icon?: ReactNode; children: ReactNode }) {
  return (
    <span className={`${styles.badge} ${styles[tone]}`}>
      {icon}
      {children}
    </span>
  );
}

/** Saldo level as status: colour never alone — always an icon and a word. */
const LEVELS: Record<ReminderLevel, { tone: Tone; label: string; icon: ReactNode }> = {
  ok: { tone: "good", label: "Aman", icon: <CheckCircle2 aria-hidden /> },
  low: { tone: "warning", label: "Tinggal ≤30%", icon: <AlertTriangle aria-hidden /> },
  critical: { tone: "serious", label: "Tinggal ≤10%", icon: <AlertTriangle aria-hidden /> },
  empty: { tone: "critical", label: "Habis", icon: <XCircle aria-hidden /> },
};

export function LevelBadge({ level }: { level: ReminderLevel }) {
  const { tone, label, icon } = LEVELS[level];
  return (
    <Badge tone={tone} icon={icon}>
      {label}
    </Badge>
  );
}

const STATUS: Record<string, { tone: Tone; label: string; icon: ReactNode }> = {
  active: { tone: "good", label: "Aktif", icon: <CircleDot aria-hidden /> },
  draft: { tone: "neutral", label: "Draf", icon: <CircleDot aria-hidden /> },
  paused: { tone: "warning", label: "Dijeda", icon: <PauseCircle aria-hidden /> },
};

export function StatusBadge({ status }: { status: string }) {
  const { tone, label, icon } = STATUS[status] ?? STATUS.draft!;
  return (
    <Badge tone={tone} icon={icon}>
      {label}
    </Badge>
  );
}
